import { FC } from 'react';
import { Button, Icon, EIconNames, Row } from '@idaho-aeyc/ui-kit';
import { useTheme } from 'styled-components';
import { TagEllipsis } from 'components/Shared/TagEllipsis';
import { EditableColumn } from 'components/Base/Table/components/EditableColumn';
import { TTagColumnContentProps } from './TagColumnContent.types';

const TagColumnContent: FC<TTagColumnContentProps> = ({
  tags,
  onOpenModal,
  isEditable,
  isAddDisabled,
}) => {
  const theme = useTheme();
  const isEmpty = !tags?.length;

  if (isAddDisabled && isEmpty) {
    return (
      <Row justify="center">
        <Button
          disabled
          tooltip={
            !isEditable ? "You don't have permission to edit tags" : undefined
          }
          icon={
            <Icon
              alt="plus icon"
              icon={EIconNames.PLUS}
              size={14}
              color={theme.colorBlackPrimary}
            />
          }
          color="primary"
          shape="circle"
          size="middle"
        />
      </Row>
    );
  }

  return (
    <EditableColumn
      onEdit={onOpenModal}
      onAdd={onOpenModal}
      isEmpty={isEmpty}
      readonly={!isEditable}
    >
      {(tags || []).map(tag => (
        <TagEllipsis
          className="mb-1"
          key={tag.value}
          text={tag.text}
          textMaxLength={20}
          color="grey"
        />
      ))}
    </EditableColumn>
  );
};

export default TagColumnContent;
